import styled from 'styled-components'

export const Root = styled.div`
    .CodeMirror-sizer {
        min-width: 0 !important;
        max-width: 1px !important;
    }
`
